import React from "react";
import { connect } from "react-redux";

import ProductHeader from "./ProductHeader";
import ProductName from "./ProductName";
import ProductQuantity from "./ProductQuantity";
import ProductCarousel from "./ProductCarousel";
import ProductDescription from "./ProductDescription";
import ProductOptions from "./ProductOptions";
import ActionButton from "../ActionButton";
import ProductSpecialRequest from "./ProductSpecialRequest";
import {
  add_promo_item,
  add_to_cart,
  editProduct,
  loadProductDetails,
  remove_from_cart,
  resetDeliveryType,
  setProduct,
} from "../../store/actions";
import ProductVariants from "./ProductVariants";
import ProductBookingSlot2 from "./ProductBookingSlot2";
import { scroller } from "react-scroll";
import { compareTime } from "../Branches/ContactPageTools";
import moment from "moment";
import StoreClosedDialog from "./StoreClosedDialog";
import ReactPixel from "@bettercart/react-facebook-pixel";
import SnapchatPixel from "react-snapchat-pixel";
import ReactAckoo from "../../ackoo";
import ReactGA from "react-ga4";
import TiktokPixel from "../../tiktok-pixel";
import TwitterPixel from "../../TwitterPixel";
import { GTM } from "../../App";
import ProductShare from "./ProductShare";
import MingledDialog from "./MingledDialog";
import SwitchBranchDialog from "./SwitchBranchDialog";
import {
  isNotExcludedProuduct,
  preciseNumber,
} from "../../store/reducers/cart";
import ProductResources from "./ProductResources";
import PreoreringDialog from "./PreoreringDialog";
import ProductExtraFields from "./ProductExtraFields";
import instance from "../../store/actions/instance";
import { registerGlanceView } from "../../store/actions/analytics";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { Helmet } from "react-helmet";
import {
  getDiscountedPrice,
  getProductDiscountAmount,
  isApplicableCategeoryPromo,
} from "../../Helpers/promotions";
import { getParentCategories, setFromQuantityBox } from "../Menu/Helpers";
import ConfirmationMessageDialog from "./ConfirmationMessageDialog";
import NotifyMeDialog from "./NotifyMeDialog";
import ScheduledAvailableMessage from "./ScheduledAvailableMessage";
import ProductRecommendations from "./ProductRecommendations";
import ProductNotification from "./ProductNotification";
import * as Sentry from "@sentry/react";
import PaymentMethodInfoDialog from "./PaymentMethodInfoDialog";
import {
  generateUniqueID,
  SnapchatAddToCart,
  TikTokViewContent,
} from "../../Helpers/analytics";
import ProductReview from "./ProductReview";
import ProductCrossSell from "./ProductCrossSell";
import axios from "axios";
import {
  getProductInventory,
  getProductUsedComponents,
} from "../../store/reducers/store";
import Klaviyo from "../../Klaviyo";

function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
}

class ProductDetails extends React.Component {
  quantity = 1;
  quantity_dict = { quantity: this.quantity };
  Special_Request = "";
  promo_items_addable_quantity = 0;
  price_with_discount = 0;
  quantityExcludedOptionsTotal = 0;
  productUsedComponents = {};

  constructor(props) {
    super(props);
    this.state = {
      quantity: 1,
      dialogOpen: false,
      MingledDialogOpen: false,
      SwitchBranchDialogOpen: false,
      PreorderingDialogOpen: false,
      PaymentMethodInfoOpen: false,

      hideOptionsBookables: false,

      // Pixel

      PageViewd: false,

      has_resources: true,
      has_resource_slots: true,
      resource: null,
      resourceSlot: null,
      resourceError: false,

      // options
      options: {},

      extraFields: {},

      hasUploadedFiles: false,
      fileUploadErrorOpen: false,

      loading: false,

      confirmationMessageOpen: false,
      scheduledAvailableMessageOpen: false,

      recommendationVisibilityRegistered: false,
      NotifyMeDialogOpen: false,
      notifyStatus: null,

      selectVariantCheck: false,
      fodooleData: null,
    };
    const editedProduct = props.location.state?.editedProduct;
    this.productUsedComponents = getProductUsedComponents(
      props.current_product,
      editedProduct
    );
    if (props.location.state?.prevState) {
      const prevState = props.location.state?.prevState;

      this.state.prevState = prevState;
      this.state.extraFields = JSON.parse(
        JSON.stringify(prevState.extraFields)
      );
      this.state.bookingslot = prevState.bookingslot;
      this.Special_Request = prevState.specialRemarks;
    } else if (props.location.state?.editMode) {
      this.quantity_dict = { quantity: editedProduct.quantity };
      this.Special_Request = editedProduct.special_request;
      this.quantityExcludedOptionsTotal = 0;

      this.quantity = editedProduct.quantity;
      this.state = {
        ...this.state,
        bookingslot: editedProduct.booking_slot,
        options: JSON.parse(JSON.stringify(editedProduct.options)),
        extraFields: JSON.parse(JSON.stringify(editedProduct.extraFields)),
        quantity: editedProduct.quantity,
        resource: editedProduct.resource,
        resourceSlot: editedProduct.resourceSlot,
      };
    }
  }

  recommendationsRef = React.createRef();

  SnapChatPageView = () => {
    SnapchatPixel.track("PAGE_VIEW", {
      item_ids: [this.props.current_product.id],
      integration: "ordable",
    });

    SnapchatPixel.track("VIEW_CONTENT", {
      item_ids: [this.props.current_product.id],
      integration: "ordable",
    });
  };
  trackViewItem = () => {
    const { settings, customerDetails } = this.props;
    if (settings.enable_snap_pixel && settings.snap_pixel) {
      const userIdentification = {
        user_email: settings.snapchat_email || "",
      }; // optional
      const options = {
        debug: false, // enable logs
      };
      SnapchatPixel.init(settings.snap_pixel, userIdentification, options);
      this.SnapChatPageView();
    }
    if (settings.enable_ackoo && settings.ackoo_api_key) {
      ReactAckoo.viewItem({
        itemId: this.props.current_product.id.toString(),
        name: this.props.current_product.name,
      });
    }
    if (settings.enable_fb_pixel && settings.fb_pixel) {
      const eventId = generateUniqueID(10);
      ReactPixel.track(
        "ViewContent",
        {
          content_ids: [this.props.current_product.id.toString()],
          content_name: this.props.current_product.name,
          content_type: "product",
          currency: settings.currency_iso,
          value: this.getTotalPrice(this.props.current_product.price, 1, true),
          event_id: eventId,
        },
        { eventID: eventId }
      );
      if (settings.enable_conversion_api) {
        instance.post("facebook/track/", {
          eventName: "ViewContent",
          customerDetails: customerDetails,
          fbc_2: localStorage.getItem("fbc_2"),
          url: window.location.href,
          event_id: eventId,
          data: {
            content_ids: this.props.current_product.id,
            content_name: this.props.current_product.name,
            content_type: "product",
            currency: settings.currency_iso,
            value: this.props.current_product.price,
            quantity: this.quantity,
          },
        });
      }
    }
    if (settings.enable_tiktok_pixel && settings.tiktok_pixel) {
      TikTokViewContent(this.props);
    }
    if (TwitterPixel.isInitialized()) {
      if (settings.twitter_events["Content View"]) {
        TwitterPixel.track(settings.twitter_events["Content View"], {
          contents: [
            {
              content_type: "product",
              content_id: this.props.current_product.id,
              content_name: this.props.current_product.name,
              content_price: this.props.current_product.price,
              num_items: this.quantity,
            },
          ],
          email_address: customerDetails?.customerContact?.email,
          phone_number: customerDetails?.customerContact?.phone,
        });
      }
    }
    if (GTM) {
      GTM.track("view_item", {
        ecommerce: {
          currency: this.props.settings.currency_iso,
          value: this.props.current_product.price,
          items: [
            {
              price: this.props.current_product.price,
              item_id: this.props.current_product.id.toString(),
              item_name: this.props.current_product.name,

              quantity: 1,
            },
          ],
        },
      });
    }
    if (Klaviyo.isInitialized()) {
      Klaviyo.track(
        "Viewed Product",
        {
          email: customerDetails?.customerContact?.email || "",
          phone_number: customerDetails?.customerContact?.phone || "",
          first_name: customerDetails?.customerContact?.name || "",
        },
        {
          ProductID: this.props.current_product.id.toString(),
          SKU: this.props.current_product.id.toString(),
          ProductName: this.props.current_product.name,
          ProductURL: window.location.href,
          URL: window.location.href,
          ImageURL: this.props.current_product.price.photo,
          Price: this.props.current_product.price,
        }
      );
    }

    if (
      this.props.settings.enable_google_analytics &&
      this.props.settings.google_analytics
    ) {
      ReactGA.gtag("event", "view_item", {
        value: this.getTotalPrice(this.props.current_product.price, 1, true),
        currency: settings.currency_iso,
        items: [
          {
            item_id: this.props.current_product.id,
            item_name: this.props.current_product.name || "",
            price: this.getTotalPrice(
              this.props.current_product.price,
              1,
              true
            ),
            quantity: 1,
          },
        ],
      });
    }

    this.setState({ PageViewd: true });
  };
  analytics = () => {
    const { settings, customerDetails } = this.props;
    if (this.props.current_product.type_of_product === "bookable") {
      if (settings.enable_fb_pixel && settings.fb_pixel) {
        ReactPixel.track("Schedule");
      }
      if (
        this.props.settings.enable_google_analytics &&
        this.props.settings.google_analytics
      ) {
        ReactGA.event({
          category: "Schedule",
          action: `User Booked ${this.props.current_product.name}`,
          label: "Schedule",
        });
      }

      if (GTM) {
        GTM.track("UserBooking", {
          item: this.props.current_product.name,
        });
      }
    } else {
      if (this.props.settings.enable_fb_pixel && this.props.settings.fb_pixel) {
        const eventId = generateUniqueID(10);
        ReactPixel.track(
          "AddToCart",
          {
            content_ids: [this.props.current_product.id?.toString().toString()],
            content_name: this.props.current_product.name,
            content_type: "product",
            currency: settings.currency_iso,
            value: this.getTotalPrice(
              this.props.current_product.price,
              1,
              true
            ),
          },
          { eventID: eventId }
        );

        if (this.props.settings.enable_conversion_api) {
          instance.post("facebook/track/", {
            eventName: "AddToCart",
            customerDetails: customerDetails,
            fbc_2: localStorage.getItem("fbc_2"),
            url: window.location.href,
            event_id: eventId,
            data: {
              content_ids: this.props.current_product.id,
              content_name: this.props.current_product.name,
              content_type: "product",
              currency: settings.currency_iso,
              value: this.getTotalPrice(
                this.props.current_product.price,
                1,
                true
              ),
              quantity: this.quantity,
            },
          });
        }
      }
      if (
        this.props.settings.enable_google_analytics &&
        this.props.settings.google_analytics
      ) {
        ReactGA.event({
          category: "Add to Cart",
          action: `User Added ${this.props.current_product.name} to Cart`,
          label: "Add to Cart",
        });

        ReactGA.gtag("event", "add_to_cart", {
          value: this.getTotalPrice(
            this.props.current_product.price,
            this.quantity,
            true
          ),
          currency: settings.currency_iso,
          items: [
            {
              item_id: this.props.current_product.id,
              item_name: this.props.current_product.name || "",
              price: 3,
              quantity: this.quantity,
            },
          ],
        });
      }
      if (GTM) {
        GTM.track("add_to_cart", {
          ecommerce: {
            items: [
              {
                item_id: this.props.current_product.id,
                item_name: this.props.current_product.name,
                currency: settings.currency_iso,
                value: this.getTotalPrice(
                  this.props.current_product.price,
                  1,
                  true
                ),
                quantity: this.quantity,
              },
            ],
          },
        });
      }
      if (
        this.props.settings.enable_snap_pixel &&
        this.props.settings.snap_pixel
      ) {
        SnapchatAddToCart(
          this.props,
          this.props.current_product,
          this.quantity,
          this.getTotalPrice(this.props.current_product.price, 1, true)
        );
      }
      if (
        this.props.settings.enable_ackoo &&
        this.props.settings.ackoo_api_key
      ) {
        ReactAckoo.addToCart({
          itemId: this.props.current_product.id.toString(),
          name: this.props.current_product.name,
          quantity: this.quantity,
          price: this.getTotalPrice(this.props.current_product.price, 1, true),
          currency: settings.currency_iso,
        });
      }

      if (settings.enable_tiktok_pixel && settings.tiktok_pixel) {
        const eventID = `AddToCart-${generateUniqueID(10)}`;
        TiktokPixel.track("AddToCart", {
          content_id: this.props.current_product.id.toString(),
          content_type: "product",
          content_name: this.props.current_product.name,
          quantity: this.quantity,
          price: this.getTotalPrice(this.props.current_product.price, 1, true),
          value: this.getTotalPrice(
            this.props.current_product.price,
            this.quantity,
            true
          ),
          currency: settings.currency_iso,
          event_id: eventID,
        });
        if (settings.enable_conversion_api_tiktok) {
          instance.post("tiktok/track/", {
            eventName: "AddToCart",
            customerDetails: customerDetails,
            ttclid: localStorage.getItem("ttclid"),
            eventID: eventID,
            url: window.location.href,
            properties: {
              contents: [
                {
                  price: this.getTotalPrice(
                    this.props.current_product.price,
                    1,
                    true
                  ),
                  content_id: this.props.current_product.id.toString(),
                  content_name: this.props.current_product.name,
                  content_type: "product",
                  quantity: this.quantity,
                },
              ],

              description: this.props.current_product.name,
              content_type: "product",
              currency: settings.currency_iso,
              value: this.getTotalPrice(
                this.props.current_product.price,
                this.quantity,
                true
              ),
            },
          });
        }
      }
      if (TwitterPixel.isInitialized()) {
        if (settings.twitter_events["Add to Cart"]) {
          TwitterPixel.track(settings.twitter_events["Add to Cart"], {
            contents: [
              {
                content_type: "product",
                content_id: this.props.current_product.id,
                content_name: this.props.current_product.name,
                content_price: this.getTotalPrice(
                  this.props.current_product.price,
                  1,
                  true
                ),
                num_items: this.quantity,
              },
            ],
            email_address: customerDetails?.customerContact?.email,
            phone_number: customerDetails?.customerContact?.phone,
          });
        }
      }

      if (Klaviyo.isInitialized()) {
        Klaviyo.track(
          "Added to Cart",
          {
            email: customerDetails?.customerContact?.email || "",
            phone_number: customerDetails?.customerContact?.phone || "",
            first_name: customerDetails?.customerContact?.name || "",
          },
          {
            ProductID: this.props.current_product.id.toString(),
            SKU: this.props.current_product.id.toString(),
            ProductName: this.props.current_product.name,
            ProductURL: window.location.href,
            URL: window.location.href,
            ImageURL: this.props.current_product.price.photo,
            Price: this.getTotalPrice(
              this.props.current_product.price,
              1,
              true
            ),
            $value: this.getTotalPrice(
              this.props.current_product.price,
              1,
              true
            ),
            Quantity: this.quantity,
          }
        );
      }
    }

    if (this.props.current_product.parent || !isEmpty(this.state.options)) {
      if (this.props.settings.enable_fb_pixel && this.props.settings.fb_pixel) {
        ReactPixel.track("CustomizeProduct");
      }

      if (
        this.props.settings.enable_google_analytics &&
        this.props.settings.google_analytics
      ) {
        ReactGA.event({
          category: "CustomizeProduct",
          action: `User Customized ${this.props.current_product.name}`,
          label: "CustomizeProduct",
        });
      }
      if (GTM) {
        GTM.track("customize_product", {
          item_id: this.props.current_product.id,
          item_name: this.props.current_product.name,
          currency: settings.currency_iso,
        });
      }
    }
  };

  fetchFodoole = async () => {
    const { settings } = this.props;
    const headers = {
      "x-api-key": settings.fodoole_api_key,
    };
    try {
      let res = this.state.fodooleData;
      let url = window.location.href;
      if (!url.endsWith("/")) url = url + "/";
      if (!res) {
        this.setState({ fodooleLoading: true });
        res = await axios.post(
          "https://api.fodoole.com:84/get_content",
          {
            url: url,
            project_id: settings.fodoole_project_id,
          },
          { headers }
        );
        this.setState({ fodooleData: res.data });
        res = res.data;
        this.setState({ fodooleLoading: false });
      }

      if (res.exist && res.statusCode === 200 && res.body) {
        const body = JSON.parse(res.body);
        const languages = Object.keys(body);
        if (languages.includes("en") || languages.includes("ar")) {
          languages.forEach((lang) => {
            if (!this.props.language.includes(lang)) return;
            const keys = Object.keys(body[lang]);

            const description = body[lang][keys[0]]["replace_text"]["S"];
            const title = body[lang][keys[1]]["replace_text"]["S"];
            try {
              if (description) {
                document.querySelector("#description").innerHTML = description;
              }
            } catch (e) {
              try {
                window.setTimeout(() => {
                  document.querySelector("#description").innerHTML =
                    description;
                }, 50);
              } catch (e) {
                console.error("failed again");
              }

              console.error(e);
            }

            const titleSelector =
              "span.text-muted.cut-text-one-line-product-name";
            try {
              if (title)
                document.querySelector(titleSelector).innerHTML = title;
            } catch (e) {}
          });
        }
      }
    } catch (e) {
      console.error(e);
    }
    if (this.state.fodooleLoading) this.setState({ fodooleLoading: false });
  };
  componentDidMount = async () => {
    document.addEventListener("scroll", this.recommendationIsInViewport);

    window.scrollTo(0, 0);
    this._ismounted = true;
    if (this.props.current_product) {
      this.trackViewItem();

      if (!this.props.current_product.has_loaded) {
        this.loadProductDetails();
      }

      const { settings } = this.props;

      if (
        settings.enable_fodoole &&
        settings.fodoole_api_key &&
        settings.fodoole_project_id
      ) {
        this.fetchFodoole();
      }
      if (settings.enable_tabby && settings.enable_tabby_widgets)
        new window.TabbyPromo({
          selector: "#TabbyPromo", // required, content of tabby Promo Snippet will be placed in element with that selector.
          currency: this.props.settings.currency_iso, // required, currency of your product. AED|SAR|KWD|BHD|QAR only supported, with no spaces or lowercase.
          price: String(this.calculateSubTotal()), // required, price or the product. 2 decimals max for AED|SAR|QAR and 3 decimals max for KWD|BHD.
          installmentsCount: 4, // Optional, for non-standard plans.
          lang: this.props.language === "arabic" ? "ar" : "en", // Optional, language of snippet and popups, if the property is not set, then it is based on the attribute 'lang' of your html tag.
          source: "product", // Optional, snippet placement; `product` for product page and `cart` for cart page.
          publicKey: this.props.settings.tabby_public_key, // required, store Public Key which identifies your account when communicating with tabby.
          merchantCode: this.props.settings.tabby_merchant_code, // required
        });
    }
  };

  shouldComponentUpdate() {
    if (!this._ismounted) return false;
    return true;
  }

  resetProduct = () => {
    this.quantity_dict = { quantity: this.quantity };
    this.Special_Request = "";
    this.quantityExcludedOptionsTotal = 0;
    this.state.options = {};

    this.productUsedComponents = getProductUsedComponents(
      this.props.current_product
    );
    this.setState({
      hideOptionsBookables: false, // What is this
      bookingslot:
        this.props.current_product?.type_of_product === "bookable"
          ? "reset"
          : null,
      PageViewd: false,
      options: {},
      extraFields: {},
      resetCarousel: true,
      resetOptions: true,
    });
  };
  loadProductDetails = async () => {
    this.setState({ loading: true });
    try {
      if (
        await this.props.loadProductDetails(
          this.props.current_product.id,
          this.props.current_product.category_id
        )
      ) {
        this.setState({
          loading: false,
          bookingslot:
            this.props.current_product?.type_of_product === "bookable"
              ? "reset"
              : null,

          resetCarousel: true,
        });
      }
    } catch (err) {}
  };

  refreshTabbyWidget = () => {
    try {
      const element = document.querySelector("#TabbyPromo");
      if (element) {
        const parent = element.parentNode;
        const nextSibling = element.nextSibling;
        element.remove();

        const newElement = document.createElement("div");
        newElement.id = "TabbyPromo";

        if (nextSibling) {
          parent.insertBefore(newElement, nextSibling);
        } else {
          parent.appendChild(newElement);
        }
      }
    } catch (e) {}
  };
  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.settings.enable_tamara_widgets) {
      try {
        if (prevProps.language !== this.props.language) {
          window.tamaraWidgetConfig.lang =
            this.props.language === "arabic" ? "ar" : "en";
        }
        window.TamaraWidgetV2.refresh();
      } catch (e) {
        console.error(e);
      }
    }

    if (this.props.settings.enable_tabby_widgets) {
      try {
        if (prevProps.language !== this.props.language) {
          this.refreshTabbyWidget();

          new window.TabbyPromo({
            selector: "#TabbyPromo", // required, content of tabby Promo Snippet will be placed in element with that selector.
            currency: this.props.settings.currency_iso, // required, currency of your product. AED|SAR|KWD|BHD|QAR only supported, with no spaces or lowercase.
            price: String(this.calculateSubTotal()), // required, price or the product. 2 decimals max for AED|SAR|QAR and 3 decimals max for KWD|BHD.
            installmentsCount: 4, // Optional, for non-standard plans.
            lang: this.props.language === "arabic" ? "ar" : "en", // Optional, language of snippet and popups, if the property is not set, then it is based on the attribute 'lang' of your html tag.
            source: "product", // Optional, snippet placement; `product` for product page and `cart` for cart page.
            publicKey: this.props.settings.tabby_public_key, // required, store Public Key which identifies your account when communicating with tabby.
            merchantCode: this.props.settings.tabby_merchant_code, // required
          });
        }
      } catch (e) {
        console.error(e);
      }
    }

    if (
      prevProps.current_product &&
      this.props.current_product &&
      prevProps.current_product.id !== this.props.current_product.id
    ) {
      this.resetProduct();
      window.scrollTo(0, 0);

      if (!this.props.current_product.has_loaded) {
        this.loadProductDetails();
      }

      if (this.state.selectVariantCheck) {
        this.setState({
          selectVariantCheck: false,
        });
      }
    }
    if (this.state.hideOptionsBookables) {
      this.setState({ hideOptionsBookables: false });
    }

    if (!this.state.PageViewd && this.props.current_product) {
      this.trackViewItem();
    }
    if (this.state.resetCarousel) {
      this.setState({ resetCarousel: false });
    }
    const { settings } = this.props;
    if (
      (this.props.language !== prevProps.language ||
        this.props.current_product?.id !== prevProps.current_product?.id) &&
      settings.enable_fodoole &&
      settings.fodoole_api_key &&
      settings.fodoole_project_id
    ) {
      if (this.props.current_product?.id !== prevProps.current_product?.id)
        this.setState({ fodooleData: null });
      // this.fetchFodoole();
      window.setTimeout(() => this.fetchFodoole(), 10);
    }

    if (
      this.state.prevState?.productID === this.props.current_product.id &&
      this.props.current_product.has_loaded
    ) {
      this.setStateFromPrevState(this.state.prevState);
      this.setState({ prevState: null });
    }
  };

  AddToCart = async (promo_items, is_preordered = false, quick = false) => {
    const { settings, current_product, non_mingled_category } = this.props;
    const editMode = this.props.location.state?.editMode;

    if (this.state.hasUploadedFiles) {
      this.setState({ loading: true });
      let uploadingStatus = await this.handleFileUpload();
      this.setState({ loading: false });
      if (uploadingStatus) {
        this.setState({ extraFields: { ...this.state.extraFields } });
        return;
      }
    }
    moment.locale("en");
    if (
      this.props.settings.is_branch_based_ordering &&
      !this.props.branch.branch &&
      !(this.props.settings.branch_count === 1)
    ) {
      if (this.props.current_product.parent) {
        this.props.setNextPage(
          `/product/${this.props.current_product.category}/${this.props.current_product.parent}/${this.props.current_product.slug}`
        );
      } else {
        this.props.setNextPage(
          `/product/${this.props.current_product.category}/${this.props.current_product.slug}`
        );
      }

      this.props.setPrevState({
        ...this.state,
        quantity: this.quantity,
        specialRemarks: this.Special_Request,
        productID: current_product.id,
      });
      this.props.history.replace("/select/branch", {
        pickupOnly: this.props.current_product.pickup_only,
        deliveryOnly: this.props.current_product.delivery_only,
      });
      return;
    }
    if (
      this.props.settings.busy_until_active &&
      this.props.settings.busy_until_time &&
      this.props.settings.busy_until_date &&
      !this.props.settings.allow_preordering &&
      ((compareTime(
        this.props.settings.busy_until_time,
        moment().format("HH:mm:ss")
      ) == 1 &&
        moment(this.props.settings.busy_until_date).format("YYYY-MM-DD") ==
          moment().format("YYYY-MM-DD")) ||
        moment(this.props.settings.busy_until_date).format("YYYY-MM-DD") >
          moment().format("YYYY-MM-DD"))
    ) {
      this.setState({ dialogOpen: true });

      return;
    }

    if (
      !(
        (!this.props.mingled_item &&
          (!this.props.cart.length ||
            !this.props.current_product.no_mingling)) ||
        (this.props.mingled_item &&
          this.props.cart.length &&
          this.props.cart[0].id === this.props.current_product.id)
      )
    ) {
      this.setState({ MingledDialogOpen: true });
      return;
    }
    let parentCategories = null;
    if (current_product.category_is_child) {
      parentCategories = getParentCategories(
        current_product.category_id,
        this.props.store.categories
      );
    }

    if (non_mingled_category) {
      if (
        current_product.category_id !== non_mingled_category &&
        parentCategories?.nonMingledParentCategory !== non_mingled_category
      ) {
        this.setState({ MingledDialogOpen: true });
        return;
      }
    } else if (this.props.cart.length) {
      if (
        current_product.category_no_mingling ||
        parentCategories?.nonMingledParentCategory
      ) {
        this.setState({ MingledDialogOpen: true });
        return;
      }
    }

    if (
      this.props.current_product.pickup_only &&
      this.props.customerAddress?.selectedDeliveryType !== 1
    ) {
      this.setState({ SwitchBranchDialogOpen: true, pickupOnly: true });
      return;
    }
    if (
      this.props.current_product.delivery_only &&
      this.props.customerAddress?.selectedDeliveryType !== 0
    ) {
      this.setState({ SwitchBranchDialogOpen: true, deliveryOnly: true });
      return;
    }

    if (this.props.current_product.type_of_product == "service") {
      if (
        !this.state.resource ||
        !this.state.resourceSlot ||
        this.state.resourceSlot == -1
      ) {
        this.setState({
          resourceError: true,
        });
        return;
      }
    }

    let scrollToID = this.validateOptions();

    if (this.state.bookingslot === -1) {
      scrollToID = "BookingSlots";
      this.SetBookingError();
    }
    if (scrollToID) {
      scroller.scrollTo(scrollToID, {
        duration: 800,
        delay: 0,
        offset: -70,
        smooth: "easeInOutQuart",
      });
    } else {
      if (editMode) {
        const editedProduct = this.props.location.state?.editedProduct;
        this.props.editProduct({
          productIndex: editedProduct.index,
          quantity: this.quantity,
          total_price: this.getTotalPrice(this.props.current_product.price, 1),
          quantityExcludedOptionsTotal: this.quantityExcludedOptionsTotal,
          price: this.props.current_product.price,
          options: this.state.options,
          specialRequest: this.Special_Request,
          extraFields: this.state.extraFields,
          booking_slot: this.state.bookingslot,
          resource: this.state.resource,
          resourceSlot: this.state.resourceSlot,
          category_is_child: this.props.current_product.category_is_child,
          category_no_mingling: this.props.current_product.category_no_mingling,
          parentCategories: parentCategories,
          id: this.props.current_product.id,
          category: this.props.current_product.category,
          category_id: this.props.current_product.category_id,
          parent: this.props.current_product.parent,
          // productUsedComponents: { ...this.productUsedComponents },
        });

        this.props.history.goBack();

        return;
      }
      if (
        this.props.current_product.confirmation_message &&
        !this.state.confirmationMessageOpen &&
        settings.enable_product_confirmation_messages
      ) {
        this.setState({ confirmationMessageOpen: true });
        return;
      }

      const categoryObj = this.props.store.categories.find(
        (cat) => cat.id === current_product.category_id
      );
      if (!categoryObj) this.props.history.replace("/");

      let scheduled_available_from = null;
      let scheduled_available_until = null;
      if (categoryObj &&
        categoryObj.scheduled_available_from &&
        categoryObj.scheduled_available_until &&
        current_product.scheduled_available_from &&
        current_product.scheduled_available_until
      ) {
        if (
          categoryObj.scheduled_available_from >
          current_product.scheduled_available_from
        ) {
          scheduled_available_from = categoryObj.scheduled_available_from;
          scheduled_available_until = categoryObj.scheduled_available_until;
        } else {
          scheduled_available_from = current_product.scheduled_available_from;
          scheduled_available_until = current_product.scheduled_available_until;
        }
      } else if (
        categoryObj &&
        categoryObj.scheduled_available_from &&
        categoryObj.scheduled_available_until
      ) {
        scheduled_available_from = categoryObj.scheduled_available_from;
        scheduled_available_until = categoryObj.scheduled_available_until;
      } else if (
        current_product.scheduled_available_from &&
        current_product.scheduled_available_until
      ) {
        scheduled_available_from = current_product.scheduled_available_from;
        scheduled_available_until = current_product.scheduled_available_until;
      }

      if (
        scheduled_available_from &&
        scheduled_available_until &&
        !this.state.scheduledAvailableMessageOpen &&
        moment(scheduled_available_from, "YYYY-MM-DDTHH:mm:ss").isAfter(
          moment()
        )
      ) {
        if (
          this.props.deliveryTime?.expected_date &&
          this.props.deliveryTime?.expected_start
        ) {
          if (
            moment(scheduled_available_from, "YYYY-MM-DDTHH:mm:ss").isAfter(
              moment(
                this.props.deliveryTime.expected_date +
                  this.props.deliveryTime.expected_start,
                "YYYY-MM-DDHH:mm:ss"
              )
            )
          ) {
            this.setState({ scheduledAvailableMessageOpen: true });
            return;
          }
        } else {
          this.setState({ scheduledAvailableMessageOpen: true });
          return;
        }
      }
      if (
        !this.state.PaymentMethodInfoOpen &&
        settings.enable_cash &&
        settings.allow_cash &&
        settings.enable_online_payments &&
        settings.enable_payments
      ) {
        if (this.props.current_product.credit_only) {
          this.setState({ PaymentMethodInfoOpen: true, creditOnly: true });
          return;
        }
        if (this.props.current_product.cash_only) {
          this.setState({ PaymentMethodInfoOpen: true, cashOnly: true });
          return;
        }
      }

      if (promo_items.length) {
        let quantity_to_be_added = this.quantity;
        for (let i = 0; i < promo_items.length; i++) {
          if (promo_items[i].quantity < this.quantity) {
            quantity_to_be_added = promo_items[i].quantity;
          }
          this.props.add_promo_item({
            id: this.props.current_product.id,
            quantity: quantity_to_be_added,
            components: this.props.current_product.components,
            category: this.props.current_product.category,
            category_id: this.props.current_product.category_id,
            options: this.state.options,
            booking_slot: this.state.bookingslot,
            parent: this.props.current_product.parent,
            total_price: 0,
            quantityExcludedOptionsTotal: 0,
            price: 0,
            is_delivered: this.props.current_product.is_delivered,
            charge_delivery: this.props.current_product.charge_delivery,
            special_request: this.Special_Request,
            preparation_time: this.props.current_product.preparation_time,

            preparation_time_threshold:
              this.props.current_product.preparation_time_threshold,

            promo: promo_items[i].promo,
            discount: promo_items[i].id,
            discountType:
              (promo_items[i].categories && "category_free") || "products",
            no_mingling: this.props.current_product.no_mingling,
            pickup_only: this.props.current_product.pickup_only,
            delivery_only: this.props.current_product.delivery_only,
            cash_only:
              settings.enable_cash &&
              settings.allow_cash &&
              settings.enable_online_payments &&
              settings.enable_payments
                ? this.props.current_product.cash_only
                : false,
            credit_only:
              settings.enable_cash &&
              settings.allow_cash &&
              settings.enable_online_payments &&
              settings.enable_payments
                ? this.props.current_product.credit_only
                : false,
            preordering_leadtime:
              this.props.current_product.preordering_leadtime,
            resource: this.state.resource,
            resourceSlot: this.state.resourceSlot,
            extraFields: this.state.extraFields,
            name: this.props.current_product.name,
            category_is_child: this.props.current_product.category_is_child,
            category_no_mingling:
              this.props.current_product.category_no_mingling,
            parentCategories: parentCategories,
            publishedDate: this.props.current_product.published_date,
            excludeVat: this.props.current_product.exclude_from_vat,
            isExternalLoylaty: promo_items[i].is_external_loyalty_reward,
            // productUsedComponents: { ...this.productUsedComponents },
          });
          this.quantity -= quantity_to_be_added;
          if (this.quantity <= 0) break;
          quantity_to_be_added = this.quantity;
        }
      }

      if (this.quantity > 0) {
        this.props.AddToCart({
          id: this.props.current_product.id,
          quantity: this.quantity,
          category: this.props.current_product.category,
          category_id: this.props.current_product.category_id,
          components: this.props.current_product.components,
          options: this.state.options,
          booking_slot: this.state.bookingslot,
          parent: this.props.current_product.parent,
          total_price: this.getTotalPrice(this.props.current_product.price, 1),
          quantityExcludedOptionsTotal: this.quantityExcludedOptionsTotal,
          price: this.props.current_product.price,
          is_delivered: this.props.current_product.is_delivered,
          charge_delivery: this.props.current_product.charge_delivery,
          special_request: this.Special_Request,
          preparation_time: this.props.current_product.preparation_time,
          preparation_time_threshold:
            this.props.current_product.preparation_time_threshold,
          no_mingling: this.props.current_product.no_mingling,
          pickup_only: this.props.current_product.pickup_only,
          delivery_only: this.props.current_product.delivery_only,
          cash_only:
            settings.enable_cash &&
            settings.allow_cash &&
            settings.enable_online_payments &&
            settings.enable_payments
              ? this.props.current_product.cash_only
              : false,
          credit_only:
            settings.enable_cash &&
            settings.allow_cash &&
            settings.enable_online_payments &&
            settings.enable_payments
              ? this.props.current_product.credit_only
              : false,
          is_preordered: is_preordered,
          preordering_leadtime: this.props.current_product.preordering_leadtime,
          resource: this.state.resource,
          resourceSlot: this.state.resourceSlot,
          extraFields: this.state.extraFields,
          name: this.props.current_product.name,
          category_is_child: this.props.current_product.category_is_child,
          category_no_mingling: this.props.current_product.category_no_mingling,
          parentCategories: parentCategories,
          publishedDate: this.props.current_product.published_date,
          excludeVat: this.props.current_product.exclude_from_vat,
          // productUsedComponents: { ...this.productUsedComponents },
        });
      }

      this.analytics();
      if (
        this.props.history.length > 2 &&
        !this.props.location?.state?.returnURL &&
        this.props.history.action !== "POP"
      ) {
        quick
          ? this.props.history.push("/checkout/confirmation")
          : ["grid", "grid2", "scroll"].includes(
              this.props.settings.store_layout
            )
          ? this.props.history.length
            ? this.props.history.goBack()
            : this.props.history.replace(
                window.location.pathname
                  .replace("/product/", "/category/")
                  .split("/")
                  .slice(0, -1)
                  .join("/")
              )
          : this.props.history.replace("/");
      } else if (
        this.props.location.state?.pending_items ||
        this.props.location.state?.returnURL
      ) {
        const pending_items = this.props.location.state.pending_items;
        if (pending_items && pending_items.length) {
          this.SendToNextPromoItem(pending_items);
        } else {
          if (this.props.location.state.returnURL) {
            this.props.history.replace(this.props.location.state.returnURL);
            return;
          }
          quick
            ? this.props.history.push("/checkout/confirmation")
            : ["grid", "grid2", "scroll"].includes(
                this.props.settings.store_layout
              )
            ? this.props.history.length
              ? this.props.history.goBack()
              : this.props.history.replace(
                  window.location.pathname
                    .replace("/product/", "/category/")
                    .split("/")
                    .slice(0, -1)
                    .join("/")
                )
            : this.props.history.replace("/");
        }
      } else {
        quick
          ? this.props.history.push("/checkout/confirmation")
          : ["grid", "grid2", "scroll"].includes(
              this.props.settings.store_layout
            )
          ? this.props.history.replace(
              window.location.pathname
                .replace("/product/", "/category/")
                .split("/")
                .slice(0, -1)
                .join("/")
            )
          : this.props.history.replace("/");
      }
    }
  };

  ScrollToVariants = () => {
    this.setState({
      selectVariantCheck: true,
    });
    scroller.scrollTo("Variants", {
      duration: 800,
      delay: 0,
      offset: -60,
      smooth: "easeInOutQuart",
    });
  };

  scrollToBookables = () => {
    this.SetBookingError();
    scroller.scrollTo("BookingSlots", {
      duration: 800,
      delay: 0,
      offset: -60,
      smooth: "easeInOutQuart",
    });
  };

  share = async () => {
    try {
      await navigator.share({
        title:
          this.props.language == "english"
            ? this.props.current_product.name
            : this.props.current_product.ar_name,
        url: window.location.href,
      });
    } catch (err) {
      console.log("not supported");
    }
  };

  SetQuantity = (quantity) => {
    this.quantity = quantity;
    this.quantity_dict.quantity = quantity;

    if (this.props.settings.enable_tamara_widgets)
      try {
        this.setState({ yeet: Math.random() });
        window.TamaraWidgetV2.refresh();
      } catch (e) {}

    if (this.props.settings.enable_tabby_widgets)
      try {
        this.refreshTabbyWidget();
        new window.TabbyPromo({
          selector: "#TabbyPromo", // required, content of tabby Promo Snippet will be placed in element with that selector.
          currency: this.props.settings.currency_iso, // required, currency of your product. AED|SAR|KWD|BHD|QAR only supported, with no spaces or lowercase.
          price: String(this.calculateSubTotal()), // required, price or the product. 2 decimals max for AED|SAR|QAR and 3 decimals max for KWD|BHD.
          installmentsCount: 4, // Optional, for non-standard plans.
          lang: this.props.language === "arabic" ? "ar" : "en", // Optional, language of snippet and popups, if the property is not set, then it is based on the attribute 'lang' of your html tag.
          source: "product", // Optional, snippet placement; `product` for product page and `cart` for cart page.
          publicKey: this.props.settings.tabby_public_key, // required, store Public Key which identifies your account when communicating with tabby.
          merchantCode: this.props.settings.tabby_merchant_code, // required
        });
      } catch (e) {
        console.error(e);
      }

    this.setState({ yeet: Math.random() });
  };
  SetBookingSlot = (booking_id) => {
    this.setState({ bookingslot: booking_id });
  };
  SetSpecialRequest = (request) => {
    this.Special_Request = request;
  };
  SetBookingError = (error) => {
    this.SetBookingError = error;
  };
  Check_Out_Of_Stock = (product, addedQuantity) => {
    const editMode = this.props.location.state?.editMode;
    const { usedComponents } = this.props;

    if (
      product &&
      !editMode &&
      ((["stocked", "composite"].includes(product.type_of_product) &&
        getProductInventory(product, usedComponents) + addedQuantity <
          product.min_addable_quantity) ||
        (this.props.current_product.type_of_product === "bookable" &&
          this.state.bookingslot === "Out") ||
        (product.max_addable_quantity !== null &&
          addedQuantity >= product.max_addable_quantity))
    ) {
      return true;
    }
    return false;
  };

  calculateSubTotal = () => {
    let calculated_quantity = this.quantity - this.promo_items_addable_quantity;
    if (calculated_quantity < 0) calculated_quantity = 0;

    return this.getTotalPrice(
      this.props.current_product.price,
      calculated_quantity,
      true,
      true
    );
  };
  setStateFromPrevState = ({ options, quantity }) => {
    const { settings, current_product, usedComponents } = this.props;

    let currentProductOptions = current_product.options;

    const newQuantity = setFromQuantityBox(quantity, this.quantity, {
      ...this.props,
      selectedOptions: {},
      booking_slot: this.state.bookingslot,
    });
    if (newQuantity !== null) {
      this.SetQuantity(newQuantity);
    }

    for (let [optionKey, option] of Object.entries(options)) {
      let existOption = currentProductOptions.find(
        (element) => element.id == optionKey
      );

      if (existOption) {
        for (let [choiceKey, choice] of Object.entries(
          option.selectedOptions
        )) {
          let existChoice = existOption.choices.find(
            (element) => element.id == choiceKey
          );
          if (existChoice) {
            if (choice.related_product && choice.inventory !== null) {
              const totalUsedComponents = { ...usedComponents };
              Object.entries(this.productUsedComponents).forEach(
                ([productId, optionQuantity]) => {
                  const newProductId = productId.toString().replace("Q", "");
                  totalUsedComponents[newProductId] =
                    (totalUsedComponents[newProductId] || 0) +
                    optionQuantity *
                      ((productId.toString().includes("Q") && 1) ||
                        newQuantity);
                }
              );

              const choiceInventory = getProductInventory(
                existChoice.related_product,
                totalUsedComponents
              );
              if (
                choiceInventory >=
                ((existOption.quantity_exclusive && 1) || newQuantity)
              ) {
                this.controlOptions(
                  existOption,
                  existChoice,
                  choice.quantity,
                  null
                );
              }
            } else {
              this.controlOptions(
                existOption,
                existChoice,
                choice.quantity,
                null
              );
            }
          }
        }
      }
    }
  };

  calculateNutritions = () => {
    const { settings, current_product } = this.props;
    if (
      !settings.show_nutrition_facts ||
      !settings.show_nutrition_facts_products
    )
      return;
    let totalCalories = this.quantity * current_product.calories;
    let totalProtein = this.quantity * current_product.protein;
    let totalCarbs = this.quantity * current_product.carbs;
    let totalFats = this.quantity * current_product.fats;
    let isDiaryFree = true;
    let isSugarFree = true;
    let isGlutenFree = true;
    let isNutFree = true;
    let isOrganic = true;
    let isVegan = true;
    let isVegetarian = true;
    let containsGluten = true;
    let containsNutsSesame = true;
    let containsDairy = true;
    let containsEgg = true;
    let containsSeafoodShellfish = true;
    let containsChilli = true;

    if (!current_product.dietary_restrictions?.includes("Dairy free"))
      isDiaryFree = false;
    if (!current_product.dietary_restrictions?.includes("Gluten free"))
      isGlutenFree = false;
    if (!current_product.dietary_restrictions?.includes("Sugar free"))
      isSugarFree = false;
    if (!current_product.dietary_restrictions?.includes("Nut free"))
      isNutFree = false;
    if (!current_product.dietary_restrictions?.includes("Vegan"))
      isVegan = false;
    if (!current_product.dietary_restrictions?.includes("Vegetarian"))
      isVegetarian = false;
    if (!current_product.dietary_restrictions?.includes("Organic"))
      isOrganic = false;
    if (!current_product.dietary_restrictions?.includes("Gluten"))
      containsGluten = false;
    if (!current_product.dietary_restrictions?.includes("Nuts/Sesame"))
      containsNutsSesame = false;
    if (!current_product.dietary_restrictions?.includes("Dairy"))
      containsDairy = false;
    if (!current_product.dietary_restrictions?.includes("Egg"))
      containsEgg = false;
    if (!current_product.dietary_restrictions?.includes("Seafood/Shellfish"))
      containsSeafoodShellfish = false;
    if (!current_product.dietary_restrictions?.includes("Chilli"))
      containsChilli = false;

    let options = this.state.options;
    let currentProductOptions = current_product.options;
    let selected_option = {};
    let res = {};

    for (let [key, value] of Object.entries(options)) {
      let existOption = currentProductOptions.find(
        (element) => element.id == key
      );
      selected_option = value.selectedOptions;
      if (existOption) {
        for (let [selected_key, selected_value] of Object.entries(
          selected_option
        )) {
          let existChoice = existOption.choices.find(
            (element) => element.id == selected_key
          );
          if (existChoice) {
            totalCalories +=
              selected_value.quantity *
              existChoice.calories *
              ((existOption.quantity_exclusive && 1) || this.quantity);
            totalProtein +=
              selected_value.quantity *
              existChoice.protein *
              ((existOption.quantity_exclusive && 1) || this.quantity);
            totalCarbs +=
              selected_value.quantity *
              existChoice.carbs *
              ((existOption.quantity_exclusive && 1) || this.quantity);
            totalFats +=
              selected_value.quantity *
              existChoice.fats *
              ((existOption.quantity_exclusive && 1) || this.quantity);
            if (existChoice.dietary_restrictions) {
              if (!existChoice.dietary_restrictions?.includes("Dairy free"))
                isDiaryFree = false;
              if (!existChoice.dietary_restrictions?.includes("Gluten free"))
                isGlutenFree = false;
              if (!existChoice.dietary_restrictions?.includes("Sugar free"))
                isSugarFree = false;
              if (!existChoice.dietary_restrictions?.includes("Nut free"))
                isNutFree = false;
              if (!existChoice.dietary_restrictions?.includes("Vegan"))
                isVegan = false;
              if (!existChoice.dietary_restrictions?.includes("Vegetarian"))
                isVegetarian = false;
              if (!existChoice.dietary_restrictions?.includes("Organic"))
                isOrganic = false;
              if (!existChoice.dietary_restrictions?.includes("Gluten"))
                containsGluten = false;
              if (!existChoice.dietary_restrictions?.includes("Nuts/Sesame"))
                containsNutsSesame = false;
              if (!existChoice.dietary_restrictions?.includes("Dairy"))
                containsDairy = false;
              if (!existChoice.dietary_restrictions?.includes("Egg"))
                containsEgg = false;
              if (
                !existChoice.dietary_restrictions?.includes("Seafood/Shellfish")
              )
                containsSeafoodShellfish = false;
              if (!existChoice.dietary_restrictions?.includes("Chilli"))
                containsChilli = false;
            }
          }
        }
      }
    }
    res = {
      totalCalories: totalCalories,
      totalProtein: totalProtein,
      totalCarbs: totalCarbs,
      totalFats: totalFats,
      isDiaryFree: isDiaryFree,
      isSugarFree: isSugarFree,
      isGlutenFree: isGlutenFree,
      isNutFree: isNutFree,
      isOrganic: isOrganic,
      isVegan: isVegan,
      isVegetarian: isVegetarian,
      containsGluten: containsGluten,
      containsNutsSesame: containsNutsSesame,
      containsDairy: containsDairy,
      containsEgg: containsEgg,
      containsSeafoodShellfish: containsSeafoodShellfish,
      containsChilli: containsChilli,
    };
    return res;
  };

  SendToNextPromoItem = async (pending_items) => {
    await this.props.history.replace("/");
    this.props.history.replace(
      `/product/${pending_items[0].category}/${
        pending_items[0].parent ? pending_items[0].parent + "/" : ""
      }${pending_items[0].slug}`,
      { pending_items: pending_items.slice(1) }
    );
  };

  checkPendingItems() {
    if (this.props.location.state && this.props.location.state.pending_items) {
      const pending_items = this.props.location.state.pending_items;
      if (pending_items && pending_items.length) {
        this.SendToNextPromoItem(pending_items);
        return null;
      }
    }
    this.props.history.replace("/");
  }

  componentWillUnmount() {
    this._ismounted = false;
    document.removeEventListener("scroll", this.recommendationIsInViewport);
  }

  recommendationIsInViewport = () => {
    if (!this.recommendationsRef) return;
    try {
      const top = this.recommendationsRef.getBoundingClientRect().top;
      if (top <= window.innerHeight) {
        if (!this.state.recommendationVisibilityRegistered) {
          this.setState({ recommendationVisibilityRegistered: true });
          this.props.registerGlanceView({
            type: "product_recommendations_view",
            source: "product details",
          });
          return;
        }
      }
    } catch (e) {}
  };

  getAddedQuantity = (ignoreMaxQuantity = false) => {
    const editedProduct = this.props.location.state?.editedProduct;
    let addedQuantity = 0;
    if (this.props.current_product) {
      if (
        !ignoreMaxQuantity &&
        !this.props.current_product.max_addable_quantity
      )
        return 0;
      this.props.cart.forEach((product) => {
        if (product.id === this.props.current_product.id)
          addedQuantity += product.quantity;
      });
    }
    return addedQuantity - (editedProduct?.quantity || 0);
  };
  getActionButtonText = (
    OutOfStock,
    preorderingMode,
    allChildrenStockedAndZeroInventory
  ) => {
    let customTexts = this.props.settings.custom_texts;
    const editMode = this.props.location.state?.editMode;
    return this.props.language == "english"
      ? !this.props.current_product.has_variants
        ? OutOfStock
          ? !preorderingMode
            ? this.props.current_product.type_of_product === "bookable"
              ? customTexts.fully_booked
              : customTexts.out_of_stock
            : "Preorder"
          : this.props.current_product.not_available
          ? customTexts.not_available
          : editMode
          ? "Edit Product"
          : customTexts.add_to_cart
        : allChildrenStockedAndZeroInventory
        ? customTexts.out_of_stock
        : customTexts.select_a_variant
      : !this.props.current_product.has_variants
      ? OutOfStock
        ? !preorderingMode
          ? this.props.current_product.type_of_product === "bookable"
            ? customTexts.fully_booked_ar
            : customTexts.out_of_stock_ar
          : "إطلب مسبقا"
        : this.props.current_product.not_available
        ? customTexts.not_available_ar
        : editMode
        ? "تعديل المنتج"
        : customTexts.add_to_cart_ar
      : allChildrenStockedAndZeroInventory
      ? customTexts.out_of_stock
      : customTexts.select_a_variant_ar;
  };

  shouldShowAddToCartButton = () => {
    const { cart, current_product } = this.props;
    if (current_product.hide_buy_button) return false;
    if (
      current_product.type_of_product == "service" &&
      (!this.state.has_resources || !this.state.has_resource_slots)
    )
      return false;
    return true;
  };

  controlOptions = (option, choice, quantity, groupID, resetOptions) => {
    let newOptions = this.state.options;
    const optionKey = !groupID ? option.id : option.id + "-" + groupID;
    if (!choice) {
      const newUsedComponents = this.productUsedComponents;
      Object.values(newOptions[optionKey].selectedOptions).forEach((ch) => {
        if (ch.maxInventory !== null && ch.related_product) {
          if (ch.related_product.type_of_product === "composite") {
            Object.entries(ch.related_product.components).forEach(
              ([productId, product]) => {
                let componentProductId = productId;
                if (option.quantity_exclusive) componentProductId += "Q";
                newUsedComponents[componentProductId] =
                  (newUsedComponents[componentProductId] || 0) -
                  ch.quantity * product.required_amount;
              }
            );
          } else {
            let componentProductId = ch.related_product.id;
            if (option.quantity_exclusive) componentProductId += "Q";

            newUsedComponents[componentProductId] =
              (newUsedComponents[componentProductId] || 0) - ch.quantity;
          }
        }
      });

      delete newOptions[optionKey];

      this.setState({
        options: newOptions,
      });

      return;
    }
    if (!newOptions[optionKey]) {
      newOptions[optionKey] = {
        selected: quantity,
        min: option.minimum,
        max: option.maximum,
        required: option.is_required,
        error: false,
        totalPrice: quantity * choice.price,
        selectedOptions: {},
        quantityExclusive: option.quantity_exclusive,
        conditionalOption: option.condition_parent,
      };
    } else {
      if (resetOptions) {
        const newUsedComponents = this.productUsedComponents;
        Object.values(newOptions[optionKey].selectedOptions).forEach((ch) => {
          if (ch.maxInventory !== null && ch.related_product) {
            if (ch.related_product.type_of_product === "composite") {
              Object.entries(ch.related_product.components).forEach(
                ([productId, product]) => {
                  let componentProductId = productId;
                  if (option.quantity_exclusive) componentProductId += "Q";
                  newUsedComponents[componentProductId] =
                    (newUsedComponents[componentProductId] || 0) -
                    ch.quantity * product.required_amount;
                }
              );
            } else {
              let componentProductId = ch.related_product.id;
              if (option.quantity_exclusive) componentProductId += "Q";

              newUsedComponents[componentProductId] =
                (newUsedComponents[componentProductId] || 0) - ch.quantity;
            }
          }
        });
        Object.keys(newOptions[optionKey]?.selectedOptions).forEach(
          (choiceId) => {
            Object.entries(newOptions).forEach(([optionId, option]) => {
              if (option.conditionalOption == choiceId) {
                delete newOptions[optionId];
              }
            });
          }
        );
        newOptions[optionKey].selected = 0;
        newOptions[optionKey].selectedOptions = {};
        newOptions[optionKey].error = false;
        newOptions[optionKey].totalPrice = 0;
      }
      newOptions[optionKey].selected += quantity;
      newOptions[optionKey].totalPrice += quantity * choice.price;

      if (newOptions[optionKey].error) {
        this.updateOptionError(newOptions[optionKey]);
      }
    }

    let choices = newOptions[optionKey].selectedOptions;

    if (!choices[choice.id]) {
      choices[choice.id] = {
        quantity: quantity,
        price: choice.price,
        related_product: choice.related_product,
        maxInventory: choice.inventory,
        preparationTime: choice.preparation_time,
        modifier: choice.modifier,
      };
    } else {
      choices[choice.id].quantity += quantity;
    }

    if (choice.inventory !== null && choice.related_product) {
      const newUsedComponents = this.productUsedComponents;
      if (choice.inventory !== null && choice.related_product) {
        if (choice.related_product.type_of_product === "composite") {
          Object.entries(choice.related_product.components).forEach(
            ([productId, product]) => {
              let componentProductId = productId;
              if (option.quantity_exclusive) componentProductId += "Q";
              newUsedComponents[componentProductId] =
                (newUsedComponents[componentProductId] || 0) +
                quantity * product.required_amount;
            }
          );
        } else {
          let componentProductId = choice.related_product.id;
          if (option.quantity_exclusive) componentProductId += "Q";

          newUsedComponents[componentProductId] =
            (newUsedComponents[componentProductId] || 0) + quantity;
        }
      }
    }

    if (choices[choice.id].quantity <= 0) {
      delete choices[choice.id];

      //Removing options added beceuse of a choice
      Object.entries(newOptions).forEach(([optionId, option]) => {
        if (option.conditionalOption == choice.id) {
          delete newOptions[optionId];
        }
      });
    }

    this.setState({
      options: newOptions,
    });
  };
  isContentEmpty = (html) => {
    if (html === true) return false;
    if (!html || typeof html !== "string") return true;

    return (
      html
        .replace(/<[^>]+>/g, "")
        .replace(/&nbsp;/gi, "")
        .replace(/\s+/g, "")
        .replace(/\u200B/g, "").length === 0
    );
  };
  validateOptions = () => {
    let scrollToID = null;
    let newOptions = this.state.options;
    let productOptions = this.props.current_product.options;
    let option;
    let numberOfChoicesLeft;
    for (let productOption of productOptions) {
      if (productOption.is_required) {
        let optionGroups = [...productOption.groups];
        if (productOption.condition_parent) {
          const parentOption = productOptions.find(
            (o) => o.id === productOption.condition_parent_option
          );

          if (parentOption) {
            optionGroups = [...parentOption.groups];
          }
        }
        if (optionGroups.length <= 0) {
          optionGroups.push(null); // incase option is not assigned to any group , push null so it can loop
        }
        optionGroups.forEach((group) => {
          const optionKey = group
            ? productOption.id + "-" + group
            : productOption.id;

          const parentKey = group
            ? productOption?.condition_parent_option + "-" + group
            : productOption?.condition_parent_option;
          option = newOptions[optionKey];
          if (!option) {
            newOptions[optionKey] = {
              selected: 0,
              min: productOption.minimum,
              max: productOption.maximum,
              required: productOption.is_required,
              error: false,
              selectedOptions: {},
              totalPrice: 0,
            };
            option = newOptions[optionKey];
          }

          if (
            option.selected <= 0 &&
            (!productOption.condition_parent ||
              newOptions[parentKey]?.selectedOptions[
                productOption.condition_parent
              ])
          ) {
            if (!scrollToID) scrollToID = optionKey;
            option.error = true;
            option.errorText = ` (This field is required)`;
            option.errorTextArabic = ` (هذا الإختيار مطلوب)`;
          } else if (
            option.selected > 0 &&
            option.selected < productOption.minimum
          ) {
            numberOfChoicesLeft = option.min - option.selected;
            if (!scrollToID) scrollToID = optionKey;
            option.error = true;
            option.errorText = ` (You need to select ${numberOfChoicesLeft} more ${
              numberOfChoicesLeft === 1 ? "item" : "items"
            })`;
            option.errorTextArabic = ` (يجب ان تختار ${numberOfChoicesLeft} إختيار إضافي)`;
          }
        });
      }
    }

    if (scrollToID) {
      this.setState({ option: newOptions });
    } else {
      let newExtraFields = this.state.extraFields;
      let ProductExtraFields = this.props.current_product.extra_fields;

      for (let ProductExtraField of ProductExtraFields) {
        const extraGroups = [...ProductExtraField.groups];
        if (extraGroups.length <= 0) {
          extraGroups.push(null); // incase option is not assigned to any group , push null so it can loop
        }
        extraGroups.forEach((group) => {
          const extraKey = group
            ? ProductExtraField.id + "-" + group
            : ProductExtraField.id;
          if (
            ProductExtraField.is_required &&
            this.isContentEmpty(newExtraFields[extraKey]?.value)
          ) {
            scrollToID = "extraField" + extraKey;
            newExtraFields[extraKey] = {
              error: true,
              errorType: "requirements",
            };
            this.setState({ extraFields: newExtraFields });
          }
        });
      }
    }
    return scrollToID;
  };
  getTotalPrice = (
    sum,
    quantity,
    fullTotal = false,
    includeDiscount = false
  ) => {
    if (quantity <= 0) return 0;
    let options = this.state.options;
    let extras = this.state.extraFields;
    let selected_option = {};
    let optionSum = 0;
    sum = sum * quantity;
    this.quantityExcludedOptionsTotal = 0;

    for (let key of Object.keys(options)) {
      optionSum = 0;
      selected_option = options[key].selectedOptions;

      if (isEmpty(selected_option)) delete options[key];
      else {
        for (let selected_key of Object.keys(selected_option)) {
          optionSum +=
            selected_option[selected_key].quantity *
            selected_option[selected_key].price;
        }
        if (options[key].quantityExclusive) {
          this.quantityExcludedOptionsTotal = preciseNumber(
            this.quantityExcludedOptionsTotal + optionSum
          );
        } else {
          sum += optionSum * quantity;
        }
      }
    }

    Object.values(extras).forEach((extra) => {
      const price = extra?.price ? Number(extra.price) : 0;

      if (extra.quantityExclusive) {
        this.quantityExcludedOptionsTotal = preciseNumber(
          this.quantityExcludedOptionsTotal + price
        );
      } else {
        sum = preciseNumber(sum + price * quantity);
      }
    });

    if (fullTotal) {
      sum = preciseNumber(sum + this.quantityExcludedOptionsTotal);
    }
    if (includeDiscount) {
      sum = getDiscountedPrice(
        sum,
        this.discountAmount,
        null,
        this.state.options,
        quantity
      );
    }

    return preciseNumber(sum);
  };
  updateOptionError = (option) => {
    const numberOfChoicesLeft = option.min - option.selected;

    if (option.selected <= 0) {
      option.errorText = option.errorText = ` (This field is required)`;
      option.errorTextArabic = ` (هذا الإختيار مطلوب)`;
    } else {
      option.errorText = ` (You need to select ${numberOfChoicesLeft} more ${
        numberOfChoicesLeft === 1 ? "item" : "items"
      })`;
      option.errorTextArabic = ` (يجب ان تختار ${numberOfChoicesLeft} إختيار إضافي)`;
    }
    if (numberOfChoicesLeft <= 0) option.error = false;
  };

  setExtrafield = (extraField, value, groupID) => {
    let newExtraFields = this.state.extraFields;
    const extraKey = !groupID ? extraField.id : extraField.id + "-" + groupID;
    if (!newExtraFields[extraKey] || newExtraFields[extraKey].error) {
      newExtraFields[extraKey] = {
        value: value,
        type: extraField.type,
        name: extraField.name,
        ar_name: extraField.ar_name,
        price: extraField.price,
        error: false,
        quantityExclusive: extraField.quantity_exclusive,
      };
    } else {
      newExtraFields[extraKey].value = value;
    }
    if (!value) {
      delete newExtraFields[extraKey];
    }
    if (extraField.type === "file") {
      this.setState({ hasUploadedFiles: true });
    }
    this.setState({ extraFields: newExtraFields });
  };
  handleFileUpload = async () => {
    let extraFields = this.state.extraFields;
    let formData = new FormData();
    let field;
    let keys = [];
    let scrollToID;
    for (let key in extraFields) {
      field = extraFields[key];
      if (field.type === "file" && field.value) {
        formData.append(`file${key}`, field.value, field.value.name);
        keys.push(key);
      }
    }
    if (!keys.length) {
      return;
    }
    formData.append(`keys`, keys);
    formData.append(`store`, this.props.store.slug);
    try {
      let res = await instance.post(
        "https://proxy.ordable.com/upload_file/",
        formData,
        {
          headers: {
            "content-type": "multipart/form-data",
          },
        }
      );

      res.data.forEach((file) => {
        if (file.file_url) {
          extraFields[file.key].file_url = file.file_url;
          extraFields[file.key].value = extraFields[file.key].value.name;
        } else if (!scrollToID) {
          scrollToID = "extraField" + file.key;
          extraFields[file.key].error = true;
          extraFields[file.key].errorType = "fail";
        }
      });
      if (scrollToID) {
        scroller.scrollTo(scrollToID, {
          duration: 800,
          delay: 0,
          offset: -70,
          smooth: "easeInOutQuart",
        });
      }
    } catch (err) {
      this.setState({ fileUploadErrorOpen: true });
      Sentry.captureException(err);
      return "-1";
    }
    this.setState({ extraFields });
    return scrollToID;
  };
  setLoading = (value) => {
    this.setState({ loading: value });
  };
  handleErrorClose = () => {
    this.setState({ fileUploadErrorOpen: "" });
  };
  getMetaDescription = () => {
    const { current_product } = this.props;

    if (!current_product) return "";

    return (
      current_product.meta_description?.substring(0, 160) ||
      current_product.short_description?.substring(0, 160) ||
      current_product.name
    );
  };

  getMetaCanonicalTag = () => {
    const { current_product } = this.props;
    if (
      //TODO: Wanted to know if this does anything , will prolly remove it later
      [995812, 995813, 995814, 995815, 995816, 995817].includes(
        current_product?.id
      )
    ) {
      return "https://www.bedayah.co/product/mubkhar/green-bedayah-hair-mubkhar";
    }

    return window.location.href;
  };
  getMetaTitle = () => {
    const { language, current_product } = this.props;

    if (!current_product) return "";
    if (language === "arabic") {
      return (
        current_product.meta_name?.substring(0, 160) ||
        current_product.ar_name ||
        current_product.name
      );
    }
    return current_product.meta_name?.substring(0, 160) || current_product.name;
  };
  isNotExcludedProuduct = (promoID) => {
    let storeDiscount = this.props.store.smart_promos.find(
      (promo) => promo.id == promoID
    );
    if (storeDiscount) {
      return isNotExcludedProuduct(
        this.props.current_product,
        storeDiscount.excluded_products,
        storeDiscount.excluded_categories
      );
    }
    return true;
  };
  handleCardCreditYes = (current_product) => {
    if (current_product.cash_only) {
      let itemIndex = 0;
      this.props.cart.forEach((product, index) => {
        if (product.credit_only) {
          this.props.remove_from_cart(index + itemIndex, product, false);
          --itemIndex;
        }
      });
      let itemIndexPromotion = 0;
      this.props.promo_items.forEach((product, index) => {
        if (product.credit_only) {
          this.props.remove_from_cart(
            index + itemIndexPromotion,
            product,
            true
          );
          --itemIndexPromotion;
        }
      });
    }
    if (current_product.credit_only) {
      let itemIndex = 0;
      this.props.cart.forEach((product, index) => {
        if (product.cash_only) {
          this.props.remove_from_cart(index + itemIndex, product, false);
          --itemIndex;
        }
      });
      let itemIndexPromotion = 0;
      this.props.promo_items.forEach((product, index) => {
        if (product.cash_only) {
          this.props.remove_from_cart(
            index + itemIndexPromotion,
            product,
            true
          );
          --itemIndexPromotion;
        }
      });
    }
  };

  render() {
    const { language, current_product, categories, settings, usedComponents } =
      this.props;
    let variants;
    let promo_items = [];
    let customTexts = this.props.settings.custom_texts;
    const is_from_SendToPromoItems =
      this.props.location.state && this.props.location.state.pending_items;
    if (!customTexts) {
      customTexts = {
        add_to_cart: "Add to Cart",
        add_to_cart_ar: "اضف للسلة",
      };
    }

    let addedQuantity = this.getAddedQuantity();

    //Check if all children products are of type "stocked" and inventory is 0 to show message "Out of stock"
    let allChildrenStockedAndZeroInventory = false;
    if (!current_product?.parent && current_product?.children?.length > 0) {
      allChildrenStockedAndZeroInventory =
        this.props.current_product?.children?.every(
          (child) =>
            child.type_of_product === "stocked" &&
            getProductInventory(child, usedComponents) === 0 &&
            !(child.allow_preordering && child.preorder_inventory > 0)
        );
    }

    let OutOfStock = this.Check_Out_Of_Stock(current_product, addedQuantity);
    const editedProduct = this.props.location.state?.editedProduct;
    const prevState = this.props.location.state?.prevState;

    const preorderingMode =
      (OutOfStock &&
        ["stocked", "composite"].includes(
          this.props.current_product.type_of_product
        ) &&
        this.props.current_product.allow_preordering &&
        this.props.current_product.preorder_inventory > 0) ||
      editedProduct?.is_preordered;

    try {
      if (!current_product) {
        if (this.props.match.params.ParentProduct) {
          let category = this.props.store.categories.find(
            (category) => category.slug === this.props.match.params.CategorySlug
          );

          if (category.has_password) {
            this.props.history.replace(`/category/${category.slug}`);
          }
          let product = category.products
            .find((item) => item.id == this.props.match.params.ParentProduct)
            .children.find(
              (child) => child.slug === this.props.match.params.ProductSlug
            );

          if (!product) {
            this.checkPendingItems();
          }

          const editedProduct = this.props.location.state?.editedProduct;
          this.productUsedComponents = getProductUsedComponents(
            product,
            editedProduct
          );
          this.props.setProduct(product);
          return <></>;
        } else if (this.props.match.params.ProductId) {
          let product = null;
          let category = null;
          this.props.store.categories.forEach((cat) => {
            let productfound = cat.products.find(
              (p) => p.id == parseInt(this.props.match.params.ProductId)
            );
            if (productfound) {
              category = cat;
              product = productfound;
            }
          });

          if (product) {
            if (category?.has_password) {
              this.props.history.replace(`/category/${category?.slug}`);
            }
            this.props.setProduct(product);
          } else {
            this.checkPendingItems();
          }

          return <></>;
        } else {
          let category = this.props.store.categories.find(
            (category) => category.slug === this.props.match.params.CategorySlug
          );
          if (category.has_password) {
            this.props.history.replace(`/category/${category.slug}`);
          }
          let product = category.products.find(
            (item) => item.slug === this.props.match.params.ProductSlug
          );

          if (!product) {
            this.checkPendingItems();
          }
          const editedProduct = this.props.location.state?.editedProduct;
          this.productUsedComponents = getProductUsedComponents(
            product,
            editedProduct
          );
          this.props.setProduct(product);
          return <></>;
        }
      } else {
        if (
          !this.state.loading &&
          (current_product.has_variants || current_product.variant_values)
        ) {
          variants = (
            <ProductVariants
              selectVariantCheck={this.state.selectVariantCheck}
              history={this.props.history}
              location={this.props.location}
            />
          );
        }
      }
    } catch (error) {
      this.checkPendingItems();
      return null;
    }
    //check if a promotional item is out of stock
    if (is_from_SendToPromoItems && OutOfStock) {
      const pending_items = this.props.location.state.pending_items;
      if (pending_items && pending_items.length) {
        this.SendToNextPromoItem(pending_items);
      }
    }
    // put on component did mount and update
    this.promo_items_addable_quantity = 0;
    const editMode = this.props.location.state?.editMode;
    if (
      (this.props.promotions.products.length ||
        this.props.promotions.category_free?.length) &&
      !editMode
    ) {
      promo_items = this.props.promotions.products
        .filter(
          (p) =>
            p.quantity > 0 &&
            ((p.has_variants &&
              p.product === this.props.current_product.parent) ||
              (!p.has_variants && p.product === this.props.current_product.id))
        )
        .concat(
          this.props.promotions.category_free.filter(
            (cd) =>
              cd.quantity > 0 &&
              isApplicableCategeoryPromo(
                cd.categories,
                this.props.current_product
              ) &&
              this.isNotExcludedProuduct(cd.promo)
          )
        );
      if (promo_items.length) {
        let new_promo_quantity = 0;
        promo_items.forEach((item) => {
          new_promo_quantity += item.quantity;
        });
        this.promo_items_addable_quantity = new_promo_quantity;
      }
    }

    this.discountAmount = getProductDiscountAmount(
      this.props.current_product,
      this.props.coupon,
      this.props.promotions,
      this.props.store.smart_promos
    );

    this.price_with_discount = getDiscountedPrice(
      this.props.current_product.price,
      this.discountAmount,
      null,
      this.state.options,
      this.quantity
    );

    const preventAddButton = this.state.loading;

    // Check published date

    const publishedIntheFuture =
      this.props.current_product.published_date &&
      moment(this.props.current_product.published_date).isAfter(moment());
    const { notifyStatus } = this.state;

    const showNotify =
      current_product.type_of_product === "stocked" &&
      !current_product.has_variants &&
      current_product.inventory_on_hand <= 0 &&
      (!current_product.allow_preordering ||
        current_product.preorder_inventory <= 0) &&
      !this.getAddedQuantity(true);
    return (
      <div
        className="w-100 h-100 mb-5"
        style={{ minHeight: window.innerHeight }}
        onClick={(e) => {
          if (preventAddButton) e.stopPropagation();
        }}
      >
        <Helmet>
          <title>{this.getMetaTitle()}</title>
          <meta name="description" content={this.getMetaDescription()} />
          <link rel="canonical" href={this.getMetaCanonicalTag()} />
        </Helmet>
        <Snackbar
          style={{ bottom: 70 }}
          open={this.state.fileUploadErrorOpen}
          autoHideDuration={6000}
          onClose={this.handleErrorClose}
        >
          <MuiAlert
            elevation={6}
            variant="filled"
            onClose={this.handleErrorClose}
            severity="error"
          >
            {(this.props.language === "arabic" &&
              "حدث خطأ ما. الرجاء المحاولة مرة اخرى") ||
              "Something went wrong. Please try again"}
          </MuiAlert>
        </Snackbar>
        <StoreClosedDialog
          dialogOpen={this.state.dialogOpen}
          onClose={() => this.setState({ dialogOpen: false })}
          untilDate={this.props.settings.busy_until_date}
          untilTime={this.props.settings.busy_until_time}
        />
        <MingledDialog
          dialogOpen={this.state.MingledDialogOpen}
          onClose={() => this.setState({ MingledDialogOpen: false })}
        />
        <SwitchBranchDialog
          dialogOpen={this.state.SwitchBranchDialogOpen}
          pickupOnly={this.state.pickupOnly}
          yes={() => {
            if (current_product.delivery_only) {
              let itemIndex = 0;
              this.props.cart.forEach((product, index) => {
                if (product.pickup_only) {
                  this.props.remove_from_cart(
                    index + itemIndex,
                    product,
                    false
                  );
                  --itemIndex;
                }
              });
              let itemIndexPromotion = 0;
              this.props.promo_items.forEach((product, index) => {
                if (product.pickup_only) {
                  this.props.remove_from_cart(
                    index + itemIndexPromotion,
                    product,
                    true
                  );
                  --itemIndexPromotion;
                }
              });
            }
            if (current_product.pickup_only) {
              let itemIndex = 0;
              this.props.cart.forEach((product, index) => {
                if (product.delivery_only) {
                  this.props.remove_from_cart(
                    index + itemIndex,
                    product,
                    false
                  );
                  --itemIndex;
                }
              });
              let itemIndexPromotion = 0;
              this.props.promo_items.forEach((product, index) => {
                if (product.delivery_only) {
                  this.props.remove_from_cart(
                    index + itemIndexPromotion,
                    product,
                    true
                  );
                  --itemIndexPromotion;
                }
              });
            }
            if (this.props.current_product.parent) {
              this.props.setNextPage(
                `/product/${this.props.current_product.category}/${this.props.current_product.parent}/${this.props.current_product.slug}`
              );
            } else {
              this.props.setNextPage(
                `/product/${this.props.current_product.category}/${this.props.current_product.slug}`,
                this.state
              );
            }

            this.props.history.replace("/select/branch", {
              pickupOnly: this.state.pickupOnly,
              deliveryOnly: this.state.deliveryOnly,
            });
          }}
          onClose={() =>
            this.setState({
              SwitchBranchDialogOpen: false,
              pickupOnly: false,
              deliveryOnly: false,
            })
          }
        />
        <PaymentMethodInfoDialog
          dialogOpen={this.state.PaymentMethodInfoOpen}
          cashOnly={this.state.cashOnly}
          creditOnly={this.state.creditOnly}
          onClose={() =>
            this.setState({
              PaymentMethodInfoOpen: false,
              cashOnly: false,
              creditOnly: false,
            })
          }
          yes={async () => {
            await this.handleCardCreditYes(current_product);
            this.AddToCart(promo_items);
          }}
        />
        <PreoreringDialog
          dialogOpen={this.state.PreorderingDialogOpen}
          yes={() => this.AddToCart(promo_items, preorderingMode)}
          onClose={() => this.setState({ PreorderingDialogOpen: false })}
          preorderingLeadTime={current_product.preordering_leadtime}
          publishedDate={current_product.published_date}
          preorderingMode={preorderingMode}
        />
        {this.props.settings.enable_product_confirmation_messages && (
          <ConfirmationMessageDialog
            dialogOpen={this.state.confirmationMessageOpen}
            yes={() => this.AddToCart(promo_items)}
            onClose={() => this.setState({ confirmationMessageOpen: false })}
            confirmationMessage={current_product.confirmation_message}
          />
        )}
        {this.state.NotifyMeDialogOpen && (
          <NotifyMeDialog
            dialogOpen={this.state.NotifyMeDialogOpen}
            productID={current_product.id}
            onClose={(status) =>
              this.setState({ NotifyMeDialogOpen: false, notifyStatus: status })
            }
          />
        )}
        {!!notifyStatus && (
          <Snackbar
            style={{ bottom: 70 }}
            open={!!notifyStatus}
            autoHideDuration={4000}
            onClose={() => this.setState({ notifyStatus: null })}
          >
            <MuiAlert
              elevation={6}
              variant="filled"
              onClose={() => this.setState({ notifyStatus: null })}
              severity={notifyStatus === "success" ? "success" : "error"}
            >
              {notifyStatus === "success"
                ? (this.props.language === "arabic" &&
                    "سوف يتم تنبيهك فور رجوع المنتج") ||
                  "You will be notifed as soon as the product is back in stock."
                : (this.props.language === "arabic" &&
                    "حدث خطأ ما. الرجاء المحاولة مرة اخرى") ||
                  "Something went wrong. Please try again"}
            </MuiAlert>
          </Snackbar>
        )}
        <ScheduledAvailableMessage
          dialogOpen={this.state.scheduledAvailableMessageOpen}
          yes={() => this.AddToCart(promo_items)}
          onClose={() =>
            this.setState({ scheduledAvailableMessageOpen: false })
          }
          product={current_product}
          category={this.props.store.categories.find(
            (cat) => cat.id === current_product.category_id
          )}
        />
        <ProductHeader
          enableSearch={true}
          onBack={() => {
            if (
              this.props.history.length > 2 &&
              this.props.history.action !== "POP" &&
              (!this.props.location.state ||
                (this.props.location.state &&
                  !this.props.location.state.pending_items))
            ) {
              this.props.history.goBack();
            } else {
              if (
                ["grid", "grid2", "scroll"].includes(
                  this.props.settings.store_layout
                )
              ) {
                this.props.history.replace(
                  "/category/" + this.props.current_product.category
                );
              } else this.props.history.replace("/");
            }
          }}
        />

        {!this.state.resetCarousel && <ProductCarousel />}

        <ProductName
          outOfStock={OutOfStock}
          discountAmount={this.discountAmount}
          location={this.props.location}
          SetQuantity={(quantity) => this.SetQuantity(quantity)}
          bookingslot={this.state.bookingslot}
          options={this.state.options}
          scrollToBookables={this.scrollToBookables}
          promo_items_addable_quantity={this.promo_items_addable_quantity}
          productUsedComponents={this.productUsedComponents}
          fodooleLoading={this.state.fodooleLoading}
          quantity={this.quantity}
        />
        {this.props.settings.enable_tamara_widgets &&
          this.calculateSubTotal() > 0 && (
            <div style={{ background: "white" }}>
              <tamara-widget
                type="tamara-summary"
                amount={this.calculateSubTotal()}
                lang={this.props.language === "arabic" ? "ar" : "en"}
                country={this.props.store.default_dial_code.toUpperCase()}
                inline-type="5"
                inline-variant="outlined"
              ></tamara-widget>
            </div>
          )}
        {this.props.settings.enable_tabby_widgets &&
          this.calculateSubTotal() > 0 && (
            <div style={{ background: "white" }}>
              <div id="TabbyPromo"></div>
            </div>
          )}

        {showNotify && (
          <ProductNotification
            openDialog={() => {
              this.setState({ NotifyMeDialogOpen: true });
            }}
          />
        )}
        {!this.props.current_product.has_variants &&
        this.props.current_product.type_of_product === "bookable" &&
        !this.state.hideOptionsBookables ? (
          <ProductBookingSlot2
            SetBookingSlot={(id) => this.SetBookingSlot(id)}
            SetBookingError={(error) => this.SetBookingError(error)}
            editedProduct={editedProduct}
            prevStateBookingSlot={prevState?.bookingslot}
            bookingslot={this.state.bookingslot}
          />
        ) : null}

        {!this.props.settings.prioritize_description_over_variant ? (
          <>
            {!editMode && variants}
            {this.props.current_product.type_of_product == "service" &&
              !this.props.current_product.has_variants && (
                <ProductResources
                  setResource={(rid) =>
                    this.setState({ resource: rid, resourceError: false })
                  }
                  setResourceSlot={(slotStr) =>
                    this.setState({
                      resourceSlot: slotStr,
                      resourceError: false,
                    })
                  }
                  resourceError={this.state.resourceError}
                  setHasResources={(val) =>
                    this.setState({ has_resources: val })
                  }
                  setHasResourceSlots={(val) =>
                    this.setState({ has_resource_slots: val })
                  }
                  resetResourcesState={() =>
                    this.setState({
                      has_resources: true,
                      has_resource_slots: true,
                      resource: null,
                      resourceSlot: null,
                      resourceError: false,
                    })
                  }
                  editedProduct={editedProduct}
                />
              )}
            <ProductDescription fodooleLoading={this.state.fodooleLoading} />
          </>
        ) : (
          <>
            <ProductDescription fodooleLoading={this.state.fodooleLoading} />
            {this.props.current_product.type_of_product == "service" &&
              !this.props.current_product.has_variants && (
                <ProductResources
                  setResource={(rid) =>
                    this.setState({ resource: rid, resourceError: false })
                  }
                  setResourceSlot={(slotStr) =>
                    this.setState({
                      resourceSlot: slotStr,
                      resourceError: false,
                    })
                  }
                  resourceError={this.state.resourceError}
                  setHasResources={(val) =>
                    this.setState({ has_resources: val })
                  }
                  setHasResourceSlots={(val) =>
                    this.setState({ has_resource_slots: val })
                  }
                  resetResourcesState={() =>
                    this.setState({
                      has_resources: true,
                      has_resource_slots: true,
                      resource: null,
                      resourceSlot: null,
                      resourceError: false,
                    })
                  }
                  editedProduct={editedProduct}
                />
              )}
            {!editMode && variants}
          </>
        )}

        {!this.props.current_product.has_variants &&
          !this.state.hideOptionsBookables &&
          this.props.current_product.options.length > 0 && (
            <ProductOptions
              productID={this.props.current_product.id}
              categoryID={this.props.current_product.category_id}
              options={this.props.current_product.options}
              optionsGroups={this.props.current_product.options_groups}
              selectedOptions={{ ...this.state.options }}
              controlOptions={this.controlOptions}
              editMode={editMode}
              setLoading={this.setLoading}
              discountAmount={this.discountAmount}
              productQuantity={this.quantity_dict}
              productUsedComponents={this.productUsedComponents}
              editedProduct={editedProduct}
              resetOptions={this.state.resetOptions}
              setResetOption={() => this.setState({ resetOptions: false })}
            />
          )}
        {this.props.current_product.extra_fields?.length > 0 && (
          <ProductExtraFields
            extraFields={this.props.current_product.extra_fields}
            selectedExtraFields={{ ...this.state.extraFields }}
            optionsGroups={
              this.props.current_product.extra_fields_options_groups
            }
            setExtrafield={this.setExtrafield}
          />
        )}
        {!this.props.current_product.has_variants &&
          this.props.current_product.allow_special_remarks &&
          !OutOfStock &&
          !this.props.store.settings.is_menu && (
            <ProductSpecialRequest
              SetSpecialRequest={(request) => this.SetSpecialRequest(request)}
              specialRequest={this.Special_Request}
            />
          )}

        {this.props.store.settings.enable_product_feedback &&
          this.props.store.settings.enable_product_feedback_staff && (
            <ProductReview
              productID={this.props.current_product.id}
              categoryID={this.props.current_product.category_id}
              parentID={this.props.current_product.parent}
              hasVariants={this.props.current_product.has_variants}
            />
          )}

        {!this.props.secondLoading &&
          this.props.settings.enable_product_cross_sell_items &&
          this.props.settings.enable_product_cross_sell_items_staff && (
            <ProductCrossSell
              productID={this.props.current_product.id}
              categoryID={this.props.current_product.category_id}
              parentID={this.props.current_product?.parent}
              crossSellCheck={this.props.current_product?.cross_sell}
            />
          )}

        {this.props.current_product.hide_quantity_box ||
        (OutOfStock && !preorderingMode) ||
        this.props.store.settings.quantity_box_location === "top" ||
        this.props.current_product.type_of_product == "service" ||
        this.props.store.settings.is_menu
          ? null
          : !this.props.current_product.has_variants && (
              <ProductQuantity
                addedQuantity={addedQuantity}
                scrollToBookables={this.scrollToBookables}
                SetQuantity={(quantity) => this.SetQuantity(quantity)}
                booking_slot={
                  this.state.bookingslot ? this.state.bookingslot : -1
                }
                promo_items_addable_quantity={
                  is_from_SendToPromoItems
                    ? this.promo_items_addable_quantity
                    : null
                }
                preorderingMode={preorderingMode}
                selectedOptions={this.state.options}
                productUsedComponents={this.productUsedComponents}
                editedProduct={this.props.location.state?.editedProduct}
                quantity={this.quantity}
              />
            )}
        {!editMode &&
          this.props.store.settings.enable_product_recommendations &&
          this.props.store.settings.enable_product_recommendations_staff &&
          !this.props.secondLoading && (
            <>
              <span
                ref={(el) => {
                  this.recommendationsRef = el;
                }}
              ></span>
              <ProductRecommendations />
            </>
          )}
        {navigator && navigator.share ? (
          <ProductShare share={() => this.share()} />
        ) : null}
        <div
          className={
            settings.show_nutrition_facts ? "free-space-105" : "free-space-50"
          }
        ></div>
        {this.shouldShowAddToCartButton() && (
          <ActionButton
            current_product={this.props.current_product}
            current_item={{
              quantity: this.quantity,
              options: this.state.options,
              booking_slot: this.state.bookingslot,
              total_price: this.getTotalPrice(
                this.props.current_product.price,
                1
              ),
              quantityExcludedOptionsTotal: this.quantityExcludedOptionsTotal,
              price: this.props.current_product.price,
              extraFields: this.state.extraFields,
              name: this.props.current_product.name,
              ar_name: this.props.current_product.ar_name,
            }}
            loading={this.state.loading}
            showNutrition={true}
            fromProduct={true}
            getNutritionalFacts={() => this.calculateNutritions()}
            onClick={() =>
              !preventAddButton
                ? !this.props.current_product.has_variants
                  ? OutOfStock || publishedIntheFuture
                    ? preorderingMode || publishedIntheFuture
                      ? this.setState({ PreorderingDialogOpen: true })
                      : ""
                    : this.props.current_product.not_available
                    ? ""
                    : this.AddToCart(promo_items)
                  : this.ScrollToVariants()
                : ""
            }
            onClickQuick={() =>
              !preventAddButton
                ? !this.props.current_product.has_variants
                  ? OutOfStock || publishedIntheFuture
                    ? preorderingMode || publishedIntheFuture
                      ? this.setState({ PreorderingDialogOpen: true })
                      : ""
                    : this.props.current_product.not_available
                    ? ""
                    : this.AddToCart(promo_items, false, true)
                  : this.ScrollToVariants()
                : ""
            }
            calculatedSubTotal={this.calculateSubTotal()}
            OutOfStock={
              OutOfStock ||
              this.props.current_product.not_available ||
              allChildrenStockedAndZeroInventory
            }
            disabled={
              (!this.props.current_product.has_variants &&
                OutOfStock &&
                !preorderingMode) ||
              this.props.current_product.not_available ||
              allChildrenStockedAndZeroInventory
            }
            subTotal={
              !this.props.current_product.has_variants &&
              !OutOfStock &&
              !this.props.current_product.not_available
                ? true
                : false
            }
            action={this.getActionButtonText(
              OutOfStock,
              preorderingMode,
              allChildrenStockedAndZeroInventory
            )}
            isDetailPage
            enableBuyNow={this.props.current_product.enable_buy_now || false}
            editMode={editMode}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    labels: state.store.labels,
    store: state.store.store,
    current_product: state.store.current_product,
    cart: state.cart.cart,
    promo_items: state.cart.promo_items,
    settings: state.store.store.settings,
    branch: state.branch,
    promotions: state.cart.discounts,
    coupon: state.cart.promos,
    mingled_item: state.cart.mingled_item,
    non_mingled_category: state.cart.non_mingled_category,
    customerAddress: state.customers.address,
    deliveryTime: state.deliveryTime,
    customerDetails: state.customers,
    secondLoading: state.store.secondLoading,
    usedComponents: state.store.used_components,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    setProduct: (product) => dispatch(setProduct(product)),
    AddToCart: (product, history) => dispatch(add_to_cart(product, history)),
    add_promo_item: (product) => dispatch(add_promo_item(product)),
    resetDeliveryType: () => dispatch(resetDeliveryType()),
    setNextPage: (nextPage) =>
      dispatch({ type: "SET_NEXT_PAGE", payload: nextPage }),
    setPrevState: (prevState) =>
      dispatch({ type: "SET_PREV_STATE", payload: prevState }),
    registerGlanceView: (data) => dispatch(registerGlanceView(data)),
    editProduct: (params) => dispatch(editProduct(params)),
    remove_from_cart: (product_index, product, PromoItem) =>
      dispatch(remove_from_cart(product_index, product, PromoItem)),
    loadProductDetails: (productID, categoryID) =>
      dispatch(loadProductDetails(productID, categoryID)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(ProductDetails);
